var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-0",attrs:{"color":"primary","disabled":_vm.disabled,"dark":!_vm.disabled},on:{"click":_vm.onClick}},[_vm._v("\n    Siguiente\n")])}
var staticRenderFns = []

export { render, staticRenderFns }